import './FilterTableRow.scss'
import { useContext, useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import FiltersContext from '../../../../Context/FiltersContext'
import { ProjectHexagon } from './ProjectHexagon'
import { COUNTRY_COLORS } from '../../../constants/country-color'
import { FilterTableRowExpanded } from './FilterTableRowExpanded'
// import { data } from '../../../data/data_actualizado_convertido'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
// import InfoOutlineIcon from '@mui/icons-material/InfoOutline'

import { useTranslation } from 'react-i18next'
import { IProyectos } from '../../../data/data.model'
import { CustomToolTip } from '../../CustomToolTip/CustomToolTip'
import { ProjectTriangle } from './ProjectTriangle'
import ScrollableTable from './ScrollableTable'

interface IFilterTableRow {
  estado: string
  data: IProyectos[]
  id_estado: string
}

export const FilterTableRow = ({
  estado,
  data,
  id_estado,
}: IFilterTableRow) => {
  const { t }: any = useTranslation()
  const { filtersSelected } = useContext(FiltersContext)
  const [displayedData, setDisplayedData] = useState<IProyectos[]>(data)
  const [isRowExpanded, setIsRowExpanded] = useState<boolean>(false)

  useEffect(() => {
    const filteredProyects = filterProjects()

    setDisplayedData(filteredProyects)
  }, [filtersSelected])

  const filterProjects = (): IProyectos[] => {
    return data.filter((project) => {
      return Object.entries(filtersSelected).every(([key, values]) => {
        // Si no hay values o si el array incluye "Todos", no filtrar por esa key
        if (
          !Array.isArray(values) ||
          values.length === 0 ||
          values.map((value) => value.value).includes(t('filters.all'))
        ) {
          return true
        }
        // Filtrar si el valor del proyecto está en los values del filtro

        const valorProyecto = project[key as keyof IProyectos]

        if (Array.isArray(valorProyecto)) {
          return valorProyecto.some((value) =>
            values.map((value) => value.value).includes(value)
          )
        }
        return values
          .map((value) => value.value)
          .includes(valorProyecto as string)
      })
    })
  }

  const getCountryColor = (country: string): string => {
    switch (country) {
      case 'brazil':
        return COUNTRY_COLORS.brazil
      case 'mexico':
        return COUNTRY_COLORS.mexico
      case 'peru':
        return COUNTRY_COLORS.peru
      case 'guyana':
        return COUNTRY_COLORS.guyana
      case 'bolivia':
        return COUNTRY_COLORS.bolivia
      case 'paraguay':
        return COUNTRY_COLORS.paraguay
      case 'argentina':
        return COUNTRY_COLORS.argentina
      case 'chile':
        return COUNTRY_COLORS.chile

      default:
        return ''
    }
  }

  return (
    <div className="table-row_container">
      <div className="table-row_mainDisplay">
        <div className="table-row_estado">
          {estado}
          <div className="table-row_estado_tooltip">
            <CustomToolTip title={t(`filters.tooltips.${id_estado}`)}>
              <InfoOutlinedIcon />
            </CustomToolTip>
          </div>
        </div>
        <div className="tabler-row_projects">
          {displayedData?.map((project, index) => {
            return (
              <ProjectTriangle
                key={index}
                project={project}
                size={10}
                fill={getCountryColor(project.country)}
              ></ProjectTriangle>
            )
          })}
        </div>

        <div
          className="table-row_expand-btn"
          onClick={() => {
            setIsRowExpanded(!isRowExpanded)
          }}
        >
          {isRowExpanded ? <RemoveIcon /> : <AddIcon />}
        </div>
      </div>
      {isRowExpanded ? (
        <ScrollableTable
          columns={[
            {
              key: 'country',
              label: t('project.country'),
              width: 200,
              translationKeyPrefix: 'countries',
            },
            {
              key: 'property_name_or_project_name',
              label: t('project.project_name'),
              width: 250,
            },
            {
              key: 'bioma_or_region',
              label: t('project.bioma_region'),
              width: 200,
              translationKeyPrefix: 'biomas',
            },

            {
              key: 'company_name',
              label: t('filters.categories.companies'),
              width: 300,
            },
            {
              key: 'area_overlap',
              label: t('filters.categories.protected_area'),
              width: 300,
              translationKeyPrefix: 'project.overlap',
            },
            {
              key: 'community_overlap',
              label: t('filters.categories.community'),
              width: 300,
              translationKeyPrefix: 'project.overlap',
            },
          ]}
          data={displayedData}
          maxHeight={600}
        />
      ) : null}
    </div>
  )
}
